import {
    FETCH_CREATE_DIARY_DATA,
    FETCH_DIARIES_BY_DATE,
} from "./actions/actionConstants";

import AppConstants from "../../../config/appConstants";
const mappingObject = {};

mappingObject[FETCH_CREATE_DIARY_DATA] = {
    url: "/ctdo",
    mockdata: "ctdo.json",
    type: "file",
    method: AppConstants.httpMethod.GET
};


mappingObject[FETCH_DIARIES_BY_DATE] = {
    url: "/tddv",
    mockdata: "etdo.json",
    type: "file",
    method: AppConstants.httpMethod.GET
};


export default mappingObject;